export enum ConditionType {
    Hold = 'HOLD',
    Lock = 'LOCK',
    Notice = 'NOTICE',
    Required = 'REQUIRED'
}

